import { render } from "./CodeReviewFixes.vue?vue&type=template&id=2dd3d8e4&scoped=true"
import script from "./CodeReviewFixes.vue?vue&type=script&lang=js"
export * from "./CodeReviewFixes.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=2dd3d8e4&scoped=true&lang=css&external"
import "./CodeReviewFixes.vue?vue&type=style&index=1&id=2dd3d8e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd3d8e4"]])

export default __exports__